<template>
    <div class="default-wrapper">
        <p class="tips">{{ msg }}</p>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        msg: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.default-wrapper {
    text-align: center;
    padding: 18px 0;
}

.tips {
    font-size: 14px;
    color: #999;
}
</style>